// extracted by mini-css-extract-plugin
module.exports = {"pagginationList":"Paggination_pagginationList__2rDTH","active":"Paggination_active__166uq"};